import React, { memo, FunctionComponent } from 'react'
import MuiSnackbar, {
  SnackbarProps as MuiSnackbarProps,
} from '@mui/material/Snackbar'
import Alert, { AlertProps } from '@mui/material/Alert'
import { Content } from './useStyles'

export type SnackbarProps = MuiSnackbarProps &
  Pick<AlertProps, 'severity' | 'onClose'>

const Snackbar: FunctionComponent<SnackbarProps> = ({
  message,
  severity,
  onClose,
  ...props
}: SnackbarProps) => {
  return (
    <MuiSnackbar {...props} onClose={onClose}>
      <Content>
        <Alert severity={severity} onClose={onClose}>
          {message}
        </Alert>
      </Content>
    </MuiSnackbar>
  )
}

Snackbar.defaultProps = {
  anchorOrigin: { vertical: 'top', horizontal: 'center' },
}

export default memo(Snackbar)
